<template>
    <div class="key-data-sup-change-audit">
        <div class="key-data-sup-change-info">
            <div class="title-container">
                <span class="sub-title">供应商信息</span>
                <i
                    :class="oldContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                    @click="handleCollapseOld"></i>
            </div>
            <div class="content" v-if="oldContentVisible">
                <el-row>
                    <el-col class="has-bg right-text" :span="3">供应商名称</el-col>
                    <el-col :span="5">{{ formData.supplierNameCn }}</el-col>
                    <el-col class="has-bg right-text" :span="3">社会信用代码</el-col>
                    <el-col :span="5">{{ formData.socialCreditCode }}</el-col>
                    <el-col class="has-bg right-text" :span="3">法人名名称</el-col>
                    <el-col :span="5">{{ formData.legalPersonName }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text no-wrap" :span="3">联系人姓名</el-col>
                    <el-col :span="5">{{ formData.contacts }}</el-col>
                    <el-col class="has-bg right-text" :span="3">注册资金(万元)</el-col>
                    <el-col :span="5">{{ formData.registeredCapital }}</el-col>
                    <el-col class="has-bg right-text" :span="3">电话</el-col>
                    <el-col :span="5">{{ formData.phone }}</el-col>
                </el-row>
                <el-row>
                    <el-col class="has-bg right-text" :span="3">营业执照图</el-col>
                    <el-col :span="13">
                        {{ formData.businessLicenseName }}
                        <el-button v-if="formData.businessLicenseName&&formData.businessLicenseName!=='-'" type="text" @click="handlePreview">
                            查看
                        </el-button>
                    </el-col>
                    <el-col class="has-bg right-text" :span="3"></el-col>
                    <el-col :span="5"></el-col>
                </el-row>
            </div>
        </div>
        <Preview v-if="attachmentShow" :attachmentShow.sync="attachmentShow" :rowData="rowData"></Preview>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import { dictWithUrl } from '@/components/lots/api'
import { getSupplierSourcingLoadDetail } from '../../../../api/storageSrcPool/warehouseSourceProcess.js'
import Preview from '../../../../components/viewAttachment.vue'

export default {
    props: {
        auditId: {
            type: String,
            default: '',
        },
    },
    components: { Preview },
    data() {
        return {
            oldContentVisible: true,
            newContentVisible: true,
            dictData: {},
            formData: {
                supplierNameCn: '-',
                socialCreditCode: '-',
                legalPersonName: '-',
                contacts: '-',
                registeredCapital: '-',
                phone: '-',
                businessLicenseName: '-',
            },
            detailData: null,
            qualificationList: [],
            attachmentShow: false,
            rowData: {},
        }
    },
    methods: {
        loadData() {
            let detailId = this.$route.query.detailId
            if (detailId === '' || detailId === undefined || detailId === null) {
                this.$message.warning('详情id不能为空')
                return false
            }
            let params = {
                id: detailId,
            }
            getSupplierSourcingLoadDetail(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.detailData = res.data
                        this.setFormData(res.data)
                    }
                })
                .catch(err => {})
        },
        handlePreview() {
            let row = this.detailData
            this.rowData = {
                downUrl: row.businessLicenseUrl,
                fileName: row.businessLicenseName,
                fileId: row.businessLicenseId,
            }
            this.attachmentShow = true
        },
        setFormData(data) {
            this.formData.supplierNameCn = data.supplierNameCn || '-'
            this.formData.socialCreditCode = data.socialCreditCode || '-'
            this.formData.legalPersonName = data.legalPersonName || '-'
            this.formData.contacts = data.contacts || '-'
            this.formData.registeredCapital = data.registeredCapital || '-'
            this.formData.phone = data.phone || '-'
            this.formData.businessLicenseName = data.businessLicenseName || '-'
        },
        handleCollapseOld() {
            this.oldContentVisible = !this.oldContentVisible
        },
        handleCollapseNew() {
            this.newContentVisible = !this.newContentVisible
        },
    },
    mounted() {
        // dictWithUrl(
        //     'SYS_PAYMENT_TYPE,BID_PAYMENT_TERMS,SRM_TRANSPORT_TYPE,SRM_SHIPPER_TYPE,SRM_COOPERATION_MODE,SU_CORPORATE_TYPE,SU_LEASE_TYPE',
        // )
        //     .then(res => {
        //         if (res && +res.code === 0) {
        //             this.dictData = res.data
        //             this.loadData()
        //         }
        //     })
        //     .catch(err => {})
        this.loadData()
    },
}
</script>
<style lang="less" scoped>
.key-data-sup-change-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}

.key-data-sup-change-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .change-type-label {
        margin-bottom: 10px;
        font-weight: bold;
    }
    .el-button--text {
        padding: 0;
    }
    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }

    .wrap-label-row .el-col {
        min-height: 50px;
    }

    .no-wrap {
        white-space: nowrap;
    }
}
</style>
